<div
  class="u-position-relative u-margin-center"
  fxLayout="row"
  fxLayoutAlign="center center"
  [ngStyle]="{ 'min-height': '750px', height: '100vh' }"
>
  <div class="u-position-absolute" [ngStyle]="{ top: '16px', left: '16px' }">
    <a
      mat-icon-button
      [routerLink]="['/']"
      aria-label="Go home"
      i18n-aria-label="@@signupView.goHome"
    >
      <mat-icon>home</mat-icon>
    </a>
  </div>
  <ng-container *ngIf="tenant | async as tenant">
    <div
      *ngIf="canSignUp"
      [ngStyle]="{ 'max-width': '400px', 'min-height': '730px', width: '95vw' }"
      class="u-width-100"
    >
      <div fxLayout="row" [ngStyle]="{ 'margin-top': '40px' }">
        <mat-icon fxFlexAlign="center" class="color-grey-300 md-18"
          >language</mat-icon
        >
        <nz-select
          [(ngModel)]="selectedLocale"
          [compareWith]="compareByCode"
          (ngModelChange)="localeSwitched(selectedLocale.code)"
          [nzDropdownMatchSelectWidth]="false"
          [nzSuffixIcon]="matIconArrowDown"
          nzBorderless
          class="color-grey-300"
        >
          <nz-option
            *ngFor="let locale of supportedLocales"
            [nzValue]="locale"
            [nzLabel]="locale.name"
            nzCustomContent
          >
            {{ locale.name }}
            <span
              *ngIf="locale.beta"
              [ngStyle]="{ padding: '4px' }"
              class="bg-color-grey-100 color-grey text-caption u-borderRadius--4px"
              >Beta</span
            >
          </nz-option>
        </nz-select>
      </div>
      <div
        class="u-card u-marginBottom-24 bg-color-white u-marginTop-16 u-padding-24 mat-elevation-z1"
      >
        <app-avatar-tenant
          [item]="tenant"
          class="u-display-block u-marginBottom-24"
          [size]="96"
        >
        </app-avatar-tenant>
        <h6 class="u-marginBottom-24">
          <ng-container
            *ngIf="
              route.snapshot.data?.invitation?.account?._id;
              else showGenericMessage
            "
            i18n="@@signupView.invitedTitle"
          >
            {{ route.snapshot.data?.invitation?.account?.first_name }}
            {{ route.snapshot.data?.invitation?.account?.last_name }}
            invited you to join
            {{ tenant?.friendly_name }}
          </ng-container>
          <ng-template #showGenericMessage>
            <ng-container i18n="@@signupView.joinTitle"
              >Join {{ tenant?.friendly_name }}</ng-container
            >
          </ng-template>
        </h6>
        <ng-container *ngIf="route.snapshot.queryParamMap.get('event')">
          <app-sign-up-event-banner
            class="u-display-block u-marginTop-8 u-marginBottom-24 bg-color-teal-100 u-padding-8 u-borderRadius--4px"
            [opportunityId]="route.snapshot.queryParamMap.get('eventId')"
          >
          </app-sign-up-event-banner>
        </ng-container>
        <ng-container
          *ngIf="route.snapshot.data?.programMembership?.program?.name"
        >
          <app-sign-up-banner
            class="u-display-block u-marginTop-8 u-marginBottom-24 bg-color-teal-100 u-padding-8 u-borderRadius--4px"
            [text]="programSignupText"
          >
          </app-sign-up-banner>
        </ng-container>
        <app-sign-up class="u-display-block" [tenant]="tenant"> </app-sign-up>
      </div>
      <p
        i18n="@@signupView.loginPrompt"
        class="u-padding-0-8 u-textAlign-center u-marginBottom-16"
      >
        Already have an account?
        <a [routerLink]="['/login']" class="color-blue">Log in</a>.
      </p>
    </div>
    <div
      *ngIf="!canSignUp"
      [ngStyle]="{ 'max-width': '400px' }"
      class="u-width-100"
    >
      <app-no-local-storage-prompt
        class="u-display-block bg-color-white u-padding-24"
      ></app-no-local-storage-prompt>
    </div>
    <a
      *ngIf="hasWebflowInstance"
      i18n="@@signupView.footerLink"
      class="u-display-block bg-color-blue u-padding-0-16 u-padding-8-0 u-position-absolute color-white u-textAlign-center"
      [ngStyle]="{ bottom: 0, left: 0, right: 0 }"
      [href]="'https://www.tenthousandcoffees.com/schools/' + tenant.name"
      [@fadeInGrowEnter]
      appTrackClick
      elementCustomId="what-is-10kc"
    >
      What is Ten Thousand Coffees?
    </a>
  </ng-container>
</div>
<ng-template #matIconArrowDown>
  <mat-icon class="color-grey-300 md-18">keyboard_arrow_down </mat-icon>
</ng-template>
